import React from "react";
import Modal from "shared/Modal";
import { ModalContainer, CloseIcon, Title, Text, ImagesContainer, AppStoreImage, QRcontainer } from "./styled";

const DownloadModal = (props) => {
  const openAppStoreLink = () => {
    window.open("https://apps.apple.com/si/app/foody/id6443809822", "_blank");
  };

  return (
    <>
      {props.isOpen && (
        <Modal width={640}>
          <ModalContainer>
            <CloseIcon src="/images/close.svg" alt="close" onClick={props.onClose} />
            <Title>Download the app</Title>
            <Text>
              Get access to this any many more recipes, meal plans and communities that will help you on your way to
              becoming a true foody.
            </Text>
            <ImagesContainer>
              <AppStoreImage src="/images/appleStore.png" alt="App Store" onClick={openAppStoreLink} />
              <QRcontainer>
                <img src="/images/qrAppCode.png" alt="qr code" />
                <p>Scan the code to download the app</p>
              </QRcontainer>
            </ImagesContainer>
          </ModalContainer>
        </Modal>
      )}
    </>
  );
};

export default DownloadModal;
